import type { ReactNode } from 'react';
import { useState } from 'react';
import { Code, Eye } from 'lucide-react';
import { Button } from '@/components/ui/button';

type MarkdownEditorProps = {
  content: string;
  onChange: (content: string) => void;
  placeholder?: string;
  // What the Preview tab shows. Only mounted while that tab is open, so a preview
  // that fetches does so on demand, not on every keystroke.
  preview: ReactNode;
};

export function MarkdownEditor({ content, onChange, placeholder = 'Enter markdown...', preview }: MarkdownEditorProps) {
  const [showPreview, setShowPreview] = useState(false);

  return (
    <div className="flex flex-col rounded-lg border border-border bg-background overflow-hidden">
      {/* Toolbar */}
      <div className="flex items-center gap-2 border-b border-border bg-muted px-4 py-2">
        <Button size="sm" variant={!showPreview ? 'default' : 'outline'} onClick={() => setShowPreview(false)}>
          <Code className="h-4 w-4 mr-2" />
          Markdown
        </Button>
        <Button size="sm" variant={showPreview ? 'default' : 'outline'} onClick={() => setShowPreview(true)}>
          <Eye className="h-4 w-4 mr-2" />
          Preview
        </Button>
      </div>

      {/* Content Area */}
      <div className="flex-1 overflow-hidden">
        {!showPreview ? (
          <textarea
            rows={15}
            name="content"
            value={content}
            onChange={(ev) => onChange(ev.target.value)}
            placeholder={placeholder}
            className="w-full h-full resize-none p-4 font-mono text-sm focus:outline-none bg-background text-foreground placeholder:text-muted-foreground overflow-auto"
          />
        ) : (
          preview
        )}
      </div>
    </div>
  );
}
